import { createSlice, PayloadAction } from '@reduxjs/toolkit'
/* eslint no-param-reassign: 0 */

export interface saleFlowState {
  [key: string]: any
}
export const initialState: saleFlowState = {
  technology: '',
  lineType: '',
  product: '',
  isCartera: false,
}

export interface FormDefaultState {
  customer?: { isValid: boolean; isValidating: null | boolean }
  signUp: { isValid: boolean; isValidating: null | boolean }
  address: { isValid: boolean; isValidating: null | boolean }
  billing: { isValid: boolean; isValidating: null | boolean }
}

interface SaleFormsState {
  shouldValidate: boolean | null
  forms: {
    [key: string]: FormDefaultState
  }
}

export const saleFormsInitialState: SaleFormsState = {
  shouldValidate: null,
  forms: {
    mainLine: {
      customer: { isValid: false, isValidating: null },
      signUp: { isValid: false, isValidating: null },
      address: { isValid: true, isValidating: false },
      billing: { isValid: true, isValidating: false },
    },
  },
}

const saleFlowSlice = createSlice({
  name: 'saleFlow',
  initialState,
  reducers: {
    changeSaleFlow: (state, action: PayloadAction<saleFlowState>) => {
      return { ...state, ...action.payload }
    },
    resetSaleFlow: () => initialState,
  },
})

const saleFormsSlice = createSlice({
  name: 'saleForms',
  initialState: saleFormsInitialState,
  reducers: {
    setShouldValidate: (state, action: PayloadAction<boolean>) => ({
      ...state,
      shouldValidate: action.payload,
    }),
    setFormValidity: (
      state,
      {
        payload: { lineId, form, isValid },
      }: PayloadAction<{ lineId: string; form: keyof FormDefaultState; isValid: boolean }>,
    ) => ({
      ...state,
      forms: {
        ...state.forms,
        [lineId]: {
          ...state.forms[lineId],
          [form]: {
            ...(state.forms[lineId] ? state.forms[lineId][form] : { isValidating: null }),
            isValid,
          },
        },
      },
    }),
    setFormValidating: (
      state,
      {
        payload: { lineId, form, isValidating },
      }: PayloadAction<{ lineId: string; form: keyof FormDefaultState; isValidating: boolean }>,
    ) => ({
      ...state,
      forms: {
        ...state.forms,
        [lineId]: {
          ...state.forms[lineId],
          [form]: {
            ...(state.forms[lineId] ? state.forms[lineId][form] : { isValid: false }),
            isValidating,
          },
        },
      },
    }),
    deleteForm: (state, action: PayloadAction<string>) => {
      const { payload } = action
      delete state.forms[payload]
      return state
    },
    resetForm() {
      return saleFormsInitialState
    },
  },
})

export const { changeSaleFlow, resetSaleFlow } = saleFlowSlice.actions
export const {
  setFormValidity,
  deleteForm,
  resetForm,
  setShouldValidate,
  setFormValidating,
} = saleFormsSlice.actions

export const saleFormsReducer = saleFormsSlice.reducer
export default saleFlowSlice.reducer
